export default __webpack_public_path__ + "static/media/gallery_02.fd28809e.jpg";